import React from "react";
import { Modal, Input, Form, Select } from "antd";
import {PRIVADO} from '../../../common/types/modalidadTrasladoType';
import global from '../../../common/utility/global';

const { Option } = Select;

class FormModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  handleChangeModalidadTraslado = (option) => {
    
    this.props.form.setFieldsValue({
      flagTransportePrivado: option.key === PRIVADO ? true : false,
      idChofer: undefined,
      idTransporte: undefined,
    }, () => {
        this.props.onChange("clear");
    });    
  }

  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log(values);
      if (!err) {
        const form = {
          id: values.id,
          idModalidadTraslado: values.idModalidadTraslado === undefined ? 0 : values.idModalidadTraslado.key,
          idChofer: values.idChofer === undefined ? 0 : values.idChofer.key,
          idTransporte: values.idTransporte === undefined ? 0 : values.idTransporte.key,
          marca: values.marca,
          color: values.color,
          modelo: values.modelo,
          placa: values.placa,
          tuc:values.tuc
        };
        this.props.onSave(form, this.props.form);
      }
    });
  };

  render() {
    
    const { getFieldDecorator } = this.props.form;
    getFieldDecorator("id", { initialValue: this.props.formValues.id });

    getFieldDecorator('flagTransportePrivado', { initialValue: this.props.formValues.flagTransportePrivado });

    return (
      <Modal
        title={
          this.props.formValues.id === 0
            ? "Registrar Vehiculo"
            : "Modificar Vehiculo"
        }
        visible={this.props.visible}
        cancelText={"Cancelar"}
        okText={"Guardar"}
        onCancel={this.handleCancel}
        onOk={this.handleOk}
        style={{ top: 30 }}
        width="650px"
      >
        <Form>
          <div className="row">
            <div className="col-md-12 form-group">
              <Form.Item label="Tipo Transporte">
                {getFieldDecorator("idModalidadTraslado", {
                  initialValue: this.props.formValues.idModalidadTraslado
                    ? { key: this.props.formValues.idModalidadTraslado }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Tipo Transporte"}
                    optionFilterProp="children"
                    onChange={this.handleChangeModalidadTraslado}
                  >
                    {this.props.formValues.modalidadTraslado.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
          </div>

          {/* <div className="row" style={{ display: this.props.form.getFieldValue('flagTransportePrivado') ? "" : "none" }}>
              <div className="col-md-12 form-group">
                <Form.Item label="Chofer">
                  {getFieldDecorator("idChofer", {
                    initialValue: this.props.formValues.idChofer
                      ? { key: this.props.formValues.idChofer }
                      : undefined,
                    rules: [
                      {
                        required: (this.props.form.getFieldValue('flagTransportePrivado')),
                        message: "Campo obligatorio.",
                      },
                    ],
                  })(
                    <Select
                      showSearch
                      labelInValue
                      placeholder={"Seleccione Chofer"}
                      optionFilterProp="children"
                    >
                      {this.props.formValues.choferes.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.numeroDocumento + " - " + item.razonSocial}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </div>
            </div> */}

            <div className="row" style={{ display: !this.props.form.getFieldValue('flagTransportePrivado') ? "" : "none" }}>
              <div className="col-md-12 form-group">
                <Form.Item label="Empresa Transporte">
                  {getFieldDecorator("idTransporte", {
                    initialValue: this.props.formValues.idTransporte
                      ? { key: this.props.formValues.idTransporte }
                      : undefined,
                    rules: [
                      {
                        required: (!this.props.form.getFieldValue('flagTransportePrivado')),
                        message: "Campo obligatorio.",
                      },
                    ],
                  })(
                    <Select
                      showSearch
                      labelInValue
                      placeholder={"Seleccione Transporte"}
                      optionFilterProp="children"
                    >
                      {this.props.formValues.transportes.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.numeroDocumento + " - " + item.razonSocial}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </div>
            </div>

          <div className="row">
            <div className="col-md-6 form-group">
              <Form.Item label="Color">
                {getFieldDecorator("color", {
                  initialValue: this.props.formValues.color,
                  rules: [
                    {
                      required: false,
                      message: "Campo obligatorio.",
                      whitespace: true,
                    },
                  ],
                })(<Input placeholder="Ingresar Color" autoComplete="off" />)}
              </Form.Item>
            </div>
            <div className="col-md-6 form-group">
              <Form.Item label="Marca">
                {getFieldDecorator("marca", {
                  initialValue: this.props.formValues.marca,
                  rules: [
                    {
                      required: false,
                      message: "Campo obligatorio.",
                      whitespace: true,
                    },
                  ],
                })(<Input placeholder="Ingresar Marca" autoComplete="off" />)}
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <Form.Item label="Modelo">
                {getFieldDecorator("modelo", {
                  initialValue: this.props.formValues.modelo,
                  rules: [
                    {
                      required: false,
                      message: "Campo obligatorio.",
                      whitespace: true,
                    },
                  ],
                })(<Input placeholder="Ingresar Modelo" autoComplete="off" />)}
              </Form.Item>
            </div>
            <div className="col-md-6 form-group">
              <Form.Item label="Placa">
                {getFieldDecorator("placa", {
                  initialValue: this.props.formValues.placa,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                      whitespace: true,
                    },
                  ],
                })(<Input placeholder="Ingresar Placa" autoComplete="off" onPaste={global.onKeyPressCopy} onKeyPress={global.onKeyPressTextNumber}
                />)}
              </Form.Item>
            </div>
          </div>


          <div className="row">
            <div className="col-md-6 form-group">
              <Form.Item label="Número de TUCE">
                {getFieldDecorator("tuc", {
                  initialValue: this.props.formValues.tuc,
                  rules: [
                    {
                      required: false,
                      message: "Campo obligatorio.",
                      whitespace: true,
                    },
                  ],
                })(<Input placeholder="Ingresar Número de TUCE" autoComplete="off"  onPaste={global.onKeyPressCopy} onKeyPress={global.onKeyPressTextNumber} />)}
              </Form.Item>
            </div>
 
          </div>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(FormModal);
